import styled from "styled-components";
import { media } from "../../layouts/utils";

export const WrapperContainer = styled.div`
  max-width: 1444px;
	width: 100%;
	z-index: 1200;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
  margin: 10px 0;
  ${media.large`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  padding-left: 70px;
  ${media.large`
    padding-left: 0px;
  `}
`;

export const PartnerImg = styled.img`
  width: 92px;
`;


export const ImagemVeloe = styled.img`
  ${media.phone`
    height: 32px;
    width: 77px;
  `}
`;
